module.exports = __webpack_public_path__ + "img/IMG_1400.21911b3a.jpg";